import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const GuestRoute = ({ children }) => {
	const { isAuthenticated } = useContext(AuthContext);

	if (isAuthenticated) {
		return <Navigate to="/portal" replace />;
	}

	return children;
};

export default GuestRoute;